import { i18n } from "../main";
import vuetify from "../plugins/vuetify";
import router from "../router/index.js";
import Vue from "vue";

export class ComponentInstance {
  constructor() {
    this.instance = null;
  }

  setInstance(component, props) {
    this.instance = new Vue({
      i18n,
      vuetify,
      router,
      render: h =>
        h(component, {
          props
        }),
      components: { someComponent: component }
    });
  }

  addToAppWrapper() {
    const notificationContainer = document.createElement("div");
    if (document && document.querySelector("#dialogs-wrapper")) {
      document
        .querySelector("#dialogs-wrapper")
        .appendChild(notificationContainer);
      this.instance.$mount(notificationContainer);
    }
  }
}
